// ホバー時のクロスヘア（縦線カーソル）の共通スタイル。recharts Tooltip の cursor に渡す。
// ロック時のガイド線（lockReferenceLine, 赤破線 #d32f2f・最前面）と区別するため淡色にする。
export const CROSSHAIR_CURSOR = { stroke: "#90a4ae", strokeWidth: 1, strokeDasharray: "3 3" };
